// extracted by mini-css-extract-plugin
export default {"root":"CopyAdornment_root__3FL0Q","active":"CopyAdornment_active__JVfOM"};